import { Injectable } from "@angular/core";
import { createStore, withProps } from "@ngneat/elf";
import { selectEntity, withActiveId, withEntities } from "@ngneat/elf-entities";
import { DefaultService, PaymentTermModel } from "@remainmybox/api";
import { Observable } from "rxjs";
import { UntilDestroy } from "@ngneat/until-destroy";
import { EntityRepository } from "../entity.repository";
import { Filter, Props } from "../filter-components";

export interface PaymentTerm extends PaymentTermModel {
  paymentTermKey: string;
}

@UntilDestroy()
@Injectable({ providedIn: "root" })
export class PaymentTermRepository extends EntityRepository<PaymentTerm> {
  protected defaultSearchProperties: string[] = ["paymentTermId", "text"];

  constructor(private readonly apiService: DefaultService) {
    super(
      createStore(
        { name: "paymentTerms" },
        withProps<Props<PaymentTermModel>>({}),
        withEntities<PaymentTerm, "paymentTermKey">({ idKey: "paymentTermKey" }),
        withActiveId()
      )
    );
  }

  public updateFilter(item: Filter) {
    this.store.update((state) => ({
      ...state,
      filter: item
    }));
    this.fetchPaymentTerms();
  }

  public fetchPaymentTerms() {
    const filter = this.store.getValue().filter;
    this.apiService
      .searchPaymentTerms(this.rsql(filter).build())
      .pipe(this.trackRequest())
      .subscribe((paymentTerms) => this.set(paymentTerms as PaymentTerm[]));
  }

  public getByKey(key: string): Observable<PaymentTermModel | undefined> {
    this.apiService.getPaymentTermByKey(key).subscribe((paymentTerm) => this.upsert(paymentTerm));
    return this.store.pipe(selectEntity(key));
  }

  public savePaymentTerm(key: string | undefined, model: PaymentTermModel) {
    if (key) {
      model.paymentTermKey = key;
      this.getAuditProperties(key, model as PaymentTerm).subscribe(completeModel => {
        model = completeModel;
      });
    }
    return this.apiService.savePaymentTerm(model).pipe(this.mapUpsert());
  }
}
